import type {
  SupplierOrderAllocationUnit,
  SupplierOrderItemAllocationPayload,
  SupplierOrderLinkPayload,
} from './api/supplierOrdersApi';

export interface SupplierOrderLinkFormValues {
  orderId?: string | null;
  allocateByItem?: boolean | null;
  supplierOrderItemId?: string | null;
  supplierOrderItemIndex?: number | null;
  allocatedQuantity?: number | null;
  allocatedUnit?: SupplierOrderAllocationUnit | null;
  allocatedCostPLN?: number | null;
  notes?: string | null;
  itemAllocations?: SupplierOrderItemAllocationPayload[];
}

interface BuildSupplierOrderLinkPayloadOptions {
  orderId?: string | null;
  canEditSupplierOrderFinance: boolean;
}

export function buildSupplierOrderLinkPayload(
  values: SupplierOrderLinkFormValues,
  options: BuildSupplierOrderLinkPayloadOptions,
): SupplierOrderLinkPayload {
  const allocateByItem = values.allocateByItem === true;
  const basePayload = {
    orderId: options.orderId || values.orderId || '',
    supplierOrderItemId: allocateByItem ? values.supplierOrderItemId || null : null,
    supplierOrderItemIndex: allocateByItem ? values.supplierOrderItemIndex ?? null : null,
    allocatedCostPLN: allocateByItem && options.canEditSupplierOrderFinance
      ? values.allocatedCostPLN ?? null
      : null,
    notes: values.notes || null,
    ...(Array.isArray(values.itemAllocations) ? { itemAllocations: values.itemAllocations } : {}),
  };

  if (!allocateByItem || values.allocatedQuantity == null) {
    return {
      ...basePayload,
      allocatedQuantity: null,
      allocatedUnit: allocateByItem ? values.allocatedUnit || null : null,
    };
  }

  if (!values.allocatedUnit) {
    throw new Error('Jednostka alokacji jest wymagana, gdy podano przypisaną ilość');
  }

  return {
    ...basePayload,
    allocatedQuantity: values.allocatedQuantity,
    allocatedUnit: values.allocatedUnit,
  };
}
